import React from 'react';
import { Card, Button, Divider, message } from 'antd';
import { getStringLength } from 'utils/utils.js';
import { connect } from 'dva';
import SkusItem from './SkusItem/Index.js';
import SkusTable from './SkusTable/Index.js';
import EditModal from './EditModal.js';
import styles from './Index.less';

@connect(() => ({}))
export default class SkusEditDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
    };

    this.handleModalOk = this.handleModalOk.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.handleAddSkus = this.handleAddSkus.bind(this);
  }

  handleAddSkus() {
    this.setState({ modalVisible: true });
  }

  handleModalOk(_value) {
    const { parentSkusLength } = this.props;
    const value = _value.trim();

    if (value === '') {
      return message.warning(`规格名称不能为空`);
    }

    if (getStringLength(value) > parentSkusLength * 2) {
      return message.warning(`规格名称不能超过${parentSkusLength}字`);
    }

    this.setState({ modalVisible: false });
    if (value !== '') {
      this.props.dispatch({
        type: 'SkusEdit/modifySkus',
        option: 'add',
        payload: {
          name: value,
        },
      });
    }
  }

  handleModalCancel() {
    this.setState({ modalVisible: false });
  }

  renderContent() {
    const {
      skusList,
      combinationList,
      type,
      lowPrice,
      highPrice,
      parentSkusLength,
      childSkusLength,
    } = this.props;
    const SkusItemList = skusList.map(item => {
      return (
        <SkusItem
          key={item.name}
          type={type}
          id={item.id}
          name={item.name}
          lastName={item.lastName}
          errorMsg={item.errorMsg}
          childList={item.childList}
          parentSkusLength={parentSkusLength}
          childSkusLength={childSkusLength}
        />
      );
    });

    if (skusList.length && combinationList.length) {
      return (
        <Card className={styles['card-container']} bordered={false}>
          {SkusItemList}
          {type === 'edit' ? (
            <Button type="primary" onClick={this.handleAddSkus}>
              + 添加规格
            </Button>
          ) : null}
          <Divider />
          {/* 规格组合明细 */}
          <SkusTable
            type={type}
            skusList={skusList}
            combinationList={combinationList}
            lowPrice={lowPrice}
            highPrice={highPrice}
          />
        </Card>
      );
    } else if (skusList.length && !combinationList.length) {
      return (
        <Card className={styles['card-container']} bordered={false}>
          {SkusItemList}
          <Button type="primary" onClick={this.handleAddSkus}>
            + 添加规格
          </Button>
        </Card>
      );
    } else if (type === 'render') {
      return <p>无</p>;
    } else {
      return (
        <Button type="primary" onClick={this.handleAddSkus}>
          + 添加规格
        </Button>
      );
    }
  }

  render() {
    const { modalVisible } = this.state;

    return (
      <div className={styles.root}>
        {this.renderContent()}
        {/* 对话框 */}
        <EditModal
          modalVisible={modalVisible}
          modalTitle="规格名称"
          modalInputPlaceholder="请输入规格名称"
          inputValue=""
          onCancel={this.handleModalCancel}
          onOk={this.handleModalOk}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/SkusEdit/Index.js